import {
    HTTP_INTERCEPTORS,
    provideHttpClient,
    withInterceptorsFromDi,
} from '@angular/common/http';
import { ModuleWithProviders, NgModule } from '@angular/core';
import { provideAuth } from '@interacta-shared/data-access-auth';
import {
    provideBackendVersionCheck,
    provideCurrentLanguage,
    provideExponentialBackoff,
    provideInteractaUserAgent,
} from '@interacta-shared/data-access-configuration';
import {
    outOfService,
    provideFirewallBlock,
} from '@interacta-shared/data-access-error';
import { provideLicenseUpgrade } from '@interacta-shared/data-access-license';
import { LicenseUpgradeDialogService } from '@interacta-shared/feature-license';
import { provideHealthCheck } from '@interacta-shared/util-common';
import { AppRoutingService } from '@modules/app-routing/app-routing.service';
import { HttpNoCacheInterceptorService } from '@modules/core/helpers/no-cache.interceptor';
import { DateFnsConfigurationService } from 'ngx-date-fns';
import { FallbackImageDirective } from './directives/fallback-image.directive';
const directives = [
    FallbackImageDirective, // keep in core.module
];

@NgModule({
    exports: [...directives],
    declarations: [...directives],
    providers: [
        provideInteractaUserAgent('interacta_web', false),
        {
            provide: HTTP_INTERCEPTORS,
            useClass: HttpNoCacheInterceptorService,
            multi: true,
        },
        provideHealthCheck(`/${outOfService}`, false),
        provideFirewallBlock(false),
        provideLicenseUpgrade(LicenseUpgradeDialogService, false),
        provideAuth(AppRoutingService, false),
        provideBackendVersionCheck(false),
        provideExponentialBackoff(false),
        provideCurrentLanguage(false),
        provideHttpClient(withInterceptorsFromDi()),
    ],
})
export class CoreModule {
    static forRoot(): ModuleWithProviders<CoreModule> {
        return {
            ngModule: CoreModule,
            providers: [{ provide: DateFnsConfigurationService }],
        };
    }
}
